import { render, staticRenderFns } from "./Linetv.vue?vue&type=template&id=201abbd6&"
import script from "./Linetv.vue?vue&type=script&lang=js&"
export * from "./Linetv.vue?vue&type=script&lang=js&"
import style0 from "./Linetv.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports